import { types } from "../types/types";
import { TVehicle } from "../../models/inventory/interfaces/vehicle.interface";
import { ISkuVariant, TSku } from "../../models/inventory/interfaces/sku.interface";

export interface ILoanVerificationReducerState {
  selectedVehicle: TVehicle | null
  selectedSku: TSku | null
  selectedVariant: ISkuVariant | null
  selectedLoanDuration: number | null
  selectedPartnership: string | null
  selectedDownPayment: number | null
}

const DEFAULT_STATE : ILoanVerificationReducerState = {
  selectedVehicle: null,
  selectedSku: null,
  selectedVariant: null,
  selectedLoanDuration: null,
  selectedDownPayment: null,
  selectedPartnership: null,
};

// eslint-disable-next-line default-param-last
export const applicationReducer = (state = DEFAULT_STATE, action: any) => {
  switch (action.type) {
    case types.applicationSetVehicle:
      return {
        ...state,
        selectedVehicle: action.payload
      };
    case types.applicationSetSku:
      return {
        ...state,
        selectedSku: action.payload
      };
    case types.applicationSetVariant:
      return {
        ...state,
        selectedVariant: action.payload
      };
    case types.applicationSetLoanTime:
      return {
        ...state,
        selectedLoanDuration: action.payload
      };
    case types.applicationSetDownPayment:
      return {
        ...state,
        selectedDownPayment: action.payload
      };
    case types.applicationPartnership:
      return {
        ...state,
        selectedPartnership: action.payload
      };
    default:
      return state;
  }
};
